import { flow } from 'fp-ts-esm/function';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';

import type { Extractor } from '../extractor-infra.js';
import { getExtractor } from '../extractor-infra.js';

const nodesAccessor = (node: Node) => (Array.isArray(node.nodes) ? node.nodes : []);

const getRootNode = (nodes: Node | Node[]): Node =>
  Array.isArray(nodes)
    ? {
        id: 'root',
        type: Node_Type.UNRECOGNIZED,
        nodes,
      }
    : nodes;

export const extract: (nodes: Node | Node[]) => Extractor<Node> = flow(
  getRootNode,
  getExtractor<Node>(nodesAccessor)
);
